<div mat-dialog-title>
  {{ 'BackOffice.ManageContracts.ContractLimit.AddLimit' | translate : locale.language }}
</div>
<div mat-dialog-content>
  <ng-container [formGroup]="limitForm">
    <div class="flex-row">
      <div class="flex-row" style="margin-top: 1rem;">
        <div class="flex-col mx-1">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>
              {{ 'BackOffice.ManageContracts.ContractLimit.Category' | translate : locale.language }}
            </mat-label>
            <mat-select placeholder="Select a category" name="category-selection" formControlName="category" >
              <mat-option *ngFor="let category of categories" [value]="category.id">{{ category.value}} </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-col mx-1">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>
              {{ 'BackOffice.ManageContracts.ContractLimit.Code'| translate : locale.language }}
            </mat-label>
            <mat-select placeholder="Select a code" name="code-selection" formControlName="code" >
              <mat-option *ngFor="let code of codes" [value]="code.id">{{ code.value}} </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-col mx-1">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>
              {{ 'BackOffice.ManageContracts.ContractLimit.Limit' | translate : locale.language }}
            </mat-label>
            <input matInput autocomplete="off" type="number" id="limitation" formControlName="limitation" />
          </mat-form-field>
        </div>
        <div class="flex-col mx-1">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>
              {{ 'BackOffice.ManageContracts.ContractLimit.Priority' | translate : locale.language }}
            </mat-label>
            <mat-select placeholder="Select a priority" name="priority-selection" formControlName="priority" >
              <mat-option *ngFor="let priority of priorities" [value]="priority.id">{{ priority.value}} </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div class="right" mat-dialog-actions>
  <button mat-button [mat-dialog-close]="null">
    {{ 'BackOffice.ManageContracts.ContractLimit.CloseButton' | translate : locale.language }}
  </button>
  <button [disabled]="formInValid()" mat-button [mat-dialog-close]="limitForm.getRawValue()">
    {{ 'BackOffice.ManageContracts.ContractLimit.SaveButton' | translate : locale.language }}
  </button>
</div>